import { flushSync } from 'react-dom'

// A navy curtain, sized to the visible content area, wipes across the page
// content over the outgoing view, holds for a beat, then wipes off to reveal
// the incoming one behind its trailing edge. Left to right going in, right to
// left with `back`. The sidebar and top bar hold still (index.css, "Curtain
// page transition"). Instant where the View Transitions API is missing
// (Firefox, older Safari), when motion is reduced, or when not `enabled`.
// Used by Templates and Requests to open their create pages and come back.
export default function runCurtainTransition({ apply, enabled = true, back = false, label = '' }) {
  const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
  const main = document.querySelector('.app-main')
  if (!enabled || typeof document.startViewTransition !== 'function' || reduced || !main) {
    apply()
    return
  }
  const root = document.documentElement
  const box = main.getBoundingClientRect()
  const top = Math.max(0, document.querySelector('.app-header')?.getBoundingClientRect().bottom || 0)

  // Only in the new state: it gets its own transition layer and is removed
  // the moment the transition ends.
  const curtain = document.createElement('div')
  curtain.className = 'create-curtain'
  curtain.setAttribute('aria-hidden', 'true')
  Object.assign(curtain.style, {
    left: `${box.left}px`,
    top: `${top}px`,
    width: `${box.width}px`,
    height: `${window.innerHeight - top}px`,
  })
  const mark = back
    ? '<path d="m12 19-7-7 7-7"/><path d="M19 12H5"/>'
    : '<path d="M5 12h14"/><path d="M12 5v14"/>'
  curtain.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${mark}</svg>`
  if (label) {
    const text = document.createElement('span')
    text.textContent = label
    curtain.appendChild(text)
  }

  root.classList.add('create-reveal')
  root.classList.toggle('create-reveal--back', back)
  const transition = document.startViewTransition(() => {
    flushSync(apply)
    window.scrollTo(0, 0)
    document.body.appendChild(curtain)
  })
  transition.ready
    .then(() => {
      if (back) return
      // The new view is live, so the incoming page's marked pieces (title,
      // steps, first controls) can cascade in as the curtain lifts.
      document.querySelectorAll('.app-main [data-create-stagger]').forEach((el, i) => {
        el.animate(
          { opacity: [0, 1], transform: ['translateY(14px)', 'translateY(0)'] },
          { duration: 380, delay: 400 + Math.min(i, 10) * 30, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'backwards' }
        )
      })
    })
    .catch(() => {})
  transition.finished.finally(() => {
    curtain.remove()
    root.classList.remove('create-reveal', 'create-reveal--back')
  })
}
